import React from 'react';

import { Card, Col, ListGroup } from 'react-bootstrap';
import MarkdownRenderer from '../../common/components/MarkdownRenderer';
import PeopleLayout from '../layout/PeopleLayout';

function ProgressionPage(props) {
  return (
    <PeopleLayout
      {...props}
      content={<ProgressionShow {...props} />}
    />
  );
}

function ProgressionShow({ jobs, intro, howToProgress }) {
  return (
    <Col md={12}>
      <Card className="mb-4">
        <Card.Body>
          <MarkdownRenderer content={intro} />
        </Card.Body>
      </Card>
      <Card className="mb-4">
        <Card.Header>Current Frameworks:</Card.Header>
        <Card.Body>
          <ListGroup>
            {jobs.map((job) => <ListGroup.Item key={job.id} action variant="light" href={`/roles/${job.id}`}>{job.title}</ListGroup.Item>)}
          </ListGroup>
        </Card.Body>
      </Card>
      <Card className="mb-4">
        <Card.Body>
          <MarkdownRenderer content={howToProgress} />
        </Card.Body>
      </Card>
    </Col>
  );
}

export default ProgressionPage;
